export default __webpack_public_path__ + "static/media/chloe.aeeb616e.png";